import React from 'react'
import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
export default function GoBack() {
    const navigate = useNavigate();
    function goBack(){
        navigate(-1)
  }
  return (
    <Button style={{ background:
      "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",color:"#fff",maxHeight:"37px"}} onClick={()=>{
        goBack()
      }}>Back</Button>
  )
}
